import { render, staticRenderFns } from "./VTask.vue?vue&type=template&id=2ec66818&"
import script from "./VTask.vue?vue&type=script&lang=ts&"
export * from "./VTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports